export const faqASL3 = [
    {
        titolo: "Ho ricevuto a casa la lettera di invito: sono obbligato a fare l'esame?",
        descrizione:
            "No, l'esame non è obbligatorio ma le consigliamo di farlo perché è scientificamente provato che fare la ricerca del sangue occulto fecale ogni due anni dopo i 50 anni può salvare molte vite: si possono trovare tumori allo stadio iniziale, e quindi più facilmente guaribili, o togliere dei piccoli polipi prima che diventino tumori"
    },
    {
        titolo: "Ho ricevuto la lettera di invito, mia moglie che è più giovane di me non l'ha ricevuta, perché?",
        descrizione:
            "Se sua moglie ha compiuto i 50 anni ma non è nata nel suo anno riceverà l'invito nei prossimi mesi"
    },
    {
        titolo: "Ho ricevuto la lettera di invito ma devo/vorrei rimandare l'esame, cosa devo fare?",
        descrizione:
            "Contatti l'unità organizzativa dello screening del tumore del colon retto allo 010 849 8986 dal lunedì al venerdì dalle 7.30 alle 12.45 o mandi una e-mail screeningcolonretto@asl3.liguria.it"
    },
    {
        titolo: "Ho ricevuto la lettera di invito ma so di avere emorroidi/ragadi: devo fare lo stesso l'esame?",
        descrizione:
            "Chieda consiglio al suo medico di famiglia"
    },
    {
        titolo: "Ho ricevuto la lettera di invito ma ho fatto da poco un esame feci / una colonscopia: devo fare lo stesso l'esame?",
        descrizione:
            "Sì, ma in entrambi i casi chieda prima consiglio al suo medico di famiglia",
    },
    {
        titolo: "Ho ricevuto la lettera di invito ma questa settimana non posso andare a ritirare la provetta: quanto tempo ho a disposizione?",
        descrizione: "Per ritirare la provetta ha a disposizione 90 giorni dalla data riportata sulla lettera di invito "
    },
    {
        titolo: "Ho ricevuto la lettera di invito ma non posso andare di persona a ritirare la provetta: cosa devo fare?",
        descrizione: "Può mandare a ritirare la provetta una persona di sua fiducia. Si ricordi di dare a questa persona la lettera di invito che lei ha ricevuto dopo averla firmata a testimonianza del suo consenso all'inserimento nel programma "
    }

];